"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OAuthTokenStrategy", {
    enumerable: true,
    get: function() {
        return OAuthTokenStrategy;
    }
});
const _common = require("@nestjs/common");
const _passport = require("@nestjs/passport");
const _passportcustom = require("passport-custom");
const _nocodbsdk = require("nocodb-sdk");
const _models = require("~/models");
const _utils = require("~/utils");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
let OAuthTokenStrategy = class OAuthTokenStrategy extends (0, _passport.PassportStrategy)(_passportcustom.Strategy, 'oauth-token') {
    // eslint-disable-next-line @typescript-eslint/ban-types
    async validate(req, callback) {
        try {
            var _req_headers;
            // Extract Bearer token from Authorization header
            const authHeader = (_req_headers = req.headers) == null ? void 0 : _req_headers.authorization;
            if (!authHeader || !authHeader.toLowerCase().startsWith('bearer ')) {
                return callback({
                    msg: 'No Bearer token provided'
                });
            }
            const token = authHeader.slice(7).trim();
            if (!token) {
                return callback({
                    msg: 'Empty Bearer token'
                });
            }
            // Get OAuth token from database
            const oAuthToken = await _models.OAuthToken.getByAccessToken(token);
            if (!oAuthToken) {
                return callback({
                    msg: 'Invalid OAuth token'
                });
            }
            if (oAuthToken.is_revoked) {
                return callback({
                    msg: 'Invalid OAuth token'
                });
            }
            if (oAuthToken.access_token_expires_at && new Date(oAuthToken.access_token_expires_at) < new Date()) {
                return callback({
                    msg: 'OAuth token expired'
                });
            }
            // Get user associated with the OAuth token
            const dbUser = await _models.User.getWithRoles(req.context, oAuthToken.fk_user_id, _extends({
                baseId: req['ncBaseId']
            }, req['ncWorkspaceId'] ? {
                workspaceId: req['ncWorkspaceId']
            } : {}));
            if (!dbUser) {
                return callback({
                    msg: 'User not found for OAuth token'
                });
            }
            // Validate resource limitations if granted_resources exist
            if (oAuthToken.granted_resources) {
                const grantedResources = oAuthToken.granted_resources;
                // Check workspace access limitation (EE only)
                if (grantedResources.workspace_id) {
                    var _req_context;
                    if (((_req_context = req.context) == null ? void 0 : _req_context.workspace_id) && req.context.workspace_id !== grantedResources.workspace_id) {
                        return callback({
                            msg: 'OAuth token access limited to specific workspace'
                        });
                    }
                }
                // Check base access limitation
                if (grantedResources.base_id) {
                    var _req_context1;
                    if (((_req_context1 = req.context) == null ? void 0 : _req_context1.base_id) && req.context.base_id !== grantedResources.base_id) {
                        return callback({
                            msg: 'OAuth token access limited to specific base'
                        });
                    }
                }
            }
            // Build user object with OAuth context
            const user = _extends({
                id: dbUser.id,
                email: dbUser.email,
                display_name: dbUser.display_name,
                roles: (0, _nocodbsdk.extractRolesObj)(dbUser.roles),
                base_roles: (0, _nocodbsdk.extractRolesObj)(dbUser.base_roles),
                is_new_user: dbUser.is_new_user
            }, dbUser.workspace_roles ? {
                workspace_roles: (0, _nocodbsdk.extractRolesObj)(dbUser.workspace_roles)
            } : {}, dbUser.org_roles ? {
                org_roles: (0, _nocodbsdk.extractRolesObj)(dbUser.org_roles)
            } : {}, {
                // OAuth-specific fields
                is_oauth_token: true,
                oauth_client_id: oAuthToken.fk_client_id,
                oauth_granted_resources: oAuthToken.granted_resources,
                oauth_scope: oAuthToken.scope,
                oauth_token_id: oAuthToken.id
            });
            return callback(null, (0, _utils.sanitiseUserObj)(user));
        } catch (error) {
            return callback({
                msg: 'OAuth token validation failed'
            });
        }
    }
};
OAuthTokenStrategy = _ts_decorate([
    (0, _common.Injectable)()
], OAuthTokenStrategy);
